import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {
  getPillColor,
  PILL_COLORS,
  PILL_KEY,
  PillColor
} from '../../models/attributes/attributeConstants';

@Component({
  selector: 'app-color-picker',
  templateUrl: 'color-picker.component.html',
  styleUrls: ['color-picker.component.scss'],
  standalone: false
})
export class ColorPickerComponent {
  readonly pillKeys = Object.values(PILL_KEY);
  readonly pillColors = PILL_COLORS;
  @Input() selectedColor: PILL_KEY;
  @Input() tagLabel: string;
  @Input() toolTip: string = 'Set tag color';
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  get currentPillColor(): PillColor {
    return getPillColor(this.selectedColor);
  }
  @Output() colorPick = new EventEmitter<PILL_KEY>();
  onColorSelect(color: PILL_KEY) {
    this.colorPick.emit(color);
    this.menuTrigger.closeMenu();
  }
}
